import React from 'react';
import Style from './Home.module.scss';
import me from '../../img/self.jpeg';
import classNames from 'classnames';
import EmojiBullet from "./EmojiBullet";
import SocialIcon from "./SocialIcon";
import {Box} from "@mui/material";
import {info} from "../../info/Info";  
import {useMediaQuery} from '@mui/material'
import title from '../../img/title.svg'
import titleSmall from '../../img/titlesmall.svg'

export default function Home({darkMode}) {
   const isSmall = useMediaQuery('(min-width:600px)');
   return (
      <Box component={'main'} display={'flex'} flexDirection={{xs: 'column', md: 'row'}} alignItems={'center'}
           justifyContent={'center'} minHeight={'calc(100vh - 175px)'}>
         <Box className={classNames(Style.avatar, Style.shadowed)} alt={'image of developer'} style={{background: info.gradient, objectFit: 'cover'}} component={'img'} src={me} width={{xs: '35vh', md: '40vh'}}
              height={{xs: '35vh', md: '40vh'}}
              borderRadius={'50%'} p={'0.75rem'} mb={{xs: '1rem', sm: 0}} mr={{xs: 0, md: '2rem'}}/>
         <Box style={{display: 'flex',flexDirection: 'column',alignItems: 'start'}}>
            <h1>Hi, I'm <span style={{background: info.gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>{info.firstName}</span><span className={Style.hand}>🤚</span>
            </h1>
            <h2 style={{display: 'flex'}}><img style={!darkMode ? {filter: 'invert(1)' } :{}} src={isSmall ? title : titleSmall }/></h2>
            <Box component={'ul'} pt={'0.8rem'} pb={'0.8rem'} width={'100%'}>
               {info.miniBio.map((bio, index) => (
                  <EmojiBullet key={index} emoji={bio.emoji} text={bio.text}/>
               ))}
            </Box>
            <Box display={'flex'}  fontSize={{xs: '2rem', md: '2.5rem'}}>
               {info.socials.map((social, index) => (
                  <SocialIcon key={index} link={social.link} icon={social.icon} label={social.label} />
               ))}
            </Box>
         </Box>
      </Box>
   )
}